// Copyright (c) 2019 Deere & Company

import './claimsearch.scss';
import React, {Component} from 'react';
import * as busyCounter from '../shared/action-creator/busy-counter';
import {
       getUserEditedInputs,
} from '../claims/common';
import { createErrorMessage /*, createSuccessMessage */ } from '../shared/action-creator/alert-messages';
import {
    filterEmpty, isAlphanumeric, isModelCdValid, isPartNumberValid,
} from '../shared/services/validator';
import { getAdminReportDownload /*, getComponentFactoryCode */ } from '../admin/repositories';
import {
    getFindClaimDownloadReports,
    getSearchedNonDeereClaimData,
} from '../claims/repositories';

import Accordion from '../app/common/components/accordion';
import BusyCounterLoadingIndicator from '../shared/components/busyCounter/busy-counter-loading-indicator';
import InputWithFaIcon from '../shared/components/labeled-input-with-fa-icon';
import LabeledDateRangePicker from '../shared/components/labeled-date-picker/LabeledDateRangePicker';
import OptionsDropDown from '../shared/components/options-drop-down';
import PropTypes from 'prop-types';
import SimpleMultipleEntryPopup from '../shared/components/simple-multiplentry-popup';
import { cloneDeep } from 'lodash';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { customizeErrorAlert } from '../shared/services/customize-error-alert-bar';
import { showLoadingIndicator } from '../shared/state/busy-counter';
import NonDeereSearchResultPanel from '../non-deere-claims/search-result-panel';
import NonDeereClaimDetails from '../non-deere-claims/components/non-deere-claim-details';

class FindNonDeereClaim extends Component {

    state = {
        factories: [],
        isSearch: false,
        isClaimDetails: false,
        selectedWarrantyClaimID: 0,
        selectedClaimData: {},
        gridAPI: {},
        claimDetailsInfo: {
            totalClaims: 0,
            displayedClaimIndex: 0,
        },
        modifiedSearch: [],
        showDropDownMenu: false,
        isPopupOpen: false,
        isValidEntry: true,
        popupName: '',
        popupPropertyName: '',
        popupPropertyValue: '',
        FactoryClaimList: [],
        selectedFactoryClaim: null,
        selectedClaimNumber: 0,
        disabled: false,
        searchInputs: {
            claimNumbers: '',
            engineSerialNumbers: '',
            partNumbers: '',
            processDate: {
                from: 0,
                to: 0,
            },
            factoryCode: '',
        },
        // componentDropdownList: [],
        claimCount: {

            basicSrcInps: 0,

            ProdSrcInps: 0,

            FuncSrcInps: 0,

            RegionCodeSrcInps: 0,

            OtherSrcInps: 0,
        },
        selectedBranchCurrency:null,
        factoryCode:''
        }


    selectedSearchInputs = {
        basicSrcInps: [
            'factoryCode',
            'claimNumbers',
            'engineSerialNumbers',
            'partNumbers',
            'processDate',
        ]
    };

    getSearchedLabels = {
        factoryCode: 'Factory Code',
        claimNumbers: 'Claim Number',
        engineSerialNumbers: 'Engine Serial Number',
        partNumbers: 'Part Number',
        processDate: 'Process Date',
    }

    componentWillMount = () => {

        this.onToggleDiv = this.onToggleDiv.bind( this );
        this.handleOutsideClick = this.handleOutsideClick.bind( this );

    }

    componentWillReceiveProps ( nextProps ) {

        if ( nextProps.reload === 'findClaim' ) {

            this.onBackToResult();
            this.onNewSearch();
            if ( nextProps.updateReload ) nextProps.updateReload();

        }

        if (
            nextProps.location &&
            this.props.location &&
            nextProps.location.key !== this.props.location.key &&
            nextProps.location.pathname === '/nondeere/claim-search'
        ) {

            this.onNewSearch();

        }

    }


    componentDidUpdate = ( prevProps, prevState ) => {

        if ( prevState.searchInputs.partNumber !== this.state.searchInputs.partNumber && this.state.searchInputs.partNumber === '' ) {

            const obj = { ...this.state.searchInputs };
            obj.includeReplacementParts = false;
            this.setState( {
                searchInputs: obj,
            } );

        }

    }

    getComponentEditedInpsCount = ( modifiedInput = this.state.modifiedSearch ) => {

        const claimCounts = cloneDeep( this.state.claimCount );

        Object.keys( this.selectedSearchInputs ).forEach( property => {

            claimCounts[property] = 0;
            modifiedInput.forEach( item => {

                if ( this.selectedSearchInputs[property].includes( item[0] ) ) {

                    claimCounts[property] += 1;

                }

            } );

        } );

        this.setState( {
            claimCount: claimCounts,
        } );

    }


    updatedSrcInputs = modifiedInput => {

        this.setState( { modifiedSearch: modifiedInput } );
        this.getComponentEditedInpsCount( modifiedInput );

    };

    onToggleDiv = () => {
        // console.log("onToggleDiv :: ");

        if ( !this.state.showDropDownMenu ) {

            document.addEventListener( 'click', this.handleOutsideClick, false );

        } else {

            document.removeEventListener( 'click', this.handleOutsideClick, false );

        }


        const status = !this.state.showDropDownMenu;
        this.setState( {
            showDropDownMenu: status,
        } );

    }


    updateFactoryCode = obj => {

    const selectedOption = {
        target: {
            name: 'factoryCode',
            value: obj === '-1' ? '' : obj,
        },
    };
   this.setState({
    factoryCode: selectedOption.target.value
      }
    );
        this.updateSearchInput( selectedOption );
        this.handleFactoryCodeChange( selectedOption.target.value );

    }


    accordionSecondaryText = () => (
        <span className="accordion-secondary-text caution">
            <span className="is-required red-font">*</span>
            Atleast One Criteria Must be Specifed
        </span>
    );

    onClosePopup = () => {

        this.setState( {
            isPopupOpen: false,

        } );

    }


    noOfEntries = entries => filterEmpty( entries ).length;

    initiatePopup = ( propertyName, obj ) => {

        if ( this.state.searchInputs.factoryCode === '' && propertyName === 'modelCdList' ) {

            this.setState( {
                isPopupOpen: false,
                popupName: obj.currentTarget.className,
                popupPropertyName: propertyName,
                popupPropertyValue: this.state.searchInputs[propertyName],

            } );

        } else {

            this.setState( {
                isPopupOpen: true,
                popupName: obj.currentTarget.className,
                popupPropertyName: propertyName,
                popupPropertyValue: this.state.searchInputs[propertyName],

            } );

        }

    }

    
    valuesHavingSeparators = propertyVal => {

        const match = ( propertyVal ).search( ',' ) > 0 ? true : /\r|\n/.exec( propertyVal ) !== null;

        return match && this.noOfEntries( propertyVal ) > 1;

    }


    validateRange = range => {

        if ( ( range.from === 0 || range.from === null || range.from === '' ) ||
            ( range.to === 0 || range.to === null || range.to === '' ) ) return false;
        return true;

    }


    onSubmit = clickedEvent => {

        const download = clickedEvent.currentTarget.className;

        this.setState( { isValidEntry: true } );

        // Factory code is required
        if ( !this.state.factoryCode ) {
            this.props.createErrorMessage( 'Please select at least one factory code.' );
            return;
        }

        const { searchInputs, factoryCode } = this.state;
        const processDate = searchInputs.processDate || { from: 0, to: 0 };

        // Build the payload in the required structure
        const payLoad = {
            factoryCode,
            claimNumbers:        filterEmpty( searchInputs.claimNumbers ),
            engineSerialNumbers: filterEmpty( searchInputs.engineSerialNumbers ),
            partNumbers:         filterEmpty( searchInputs.partNumbers ),
            processDate: {
                from: processDate.from > 0 ? new Date( processDate.from ).getTime() / 1000 : 0,
                to:   processDate.to   > 0 ? new Date( processDate.to   ).getTime() / 1000 : 0,
            },
        };

        // At least one search criterion must be filled (factoryCode alone is sufficient)
        const anyFilled = !!factoryCode ||
            payLoad.claimNumbers.length > 0 ||
            payLoad.engineSerialNumbers.length > 0 ||
            payLoad.partNumbers.length > 0 ||
            payLoad.processDate.from !== '' ||
            payLoad.processDate.to   !== '';

        setTimeout( () => {

            if ( !anyFilled ) {

                customizeErrorAlert( 'Please fill any mandatory field' );

            } else if ( download.indexOf( 'downlaod' ) >= 0 ) {

                if ( factoryCode === 'liebherr' ) {

                    this.getNonDeereClaimDownloadReport( 'non-deere-default-report', payLoad, 'non-deere-default-report.xls' );

                }
                if ( factoryCode === 'claas' ) {

                    this.getNonDeereClaimDownloadReport( 'claas-default-report', payLoad, 'claas-default-report.xls' );

                }

            } else {

                this.props.increaseCounter();
                getSearchedNonDeereClaimData( payLoad ).then( response => {

                    this.setState( {
                        isSearch: true,
                        claimList: response.claims,
                    } );
                    this.props.decreaseCounter();

                } ).catch( () => {

                    this.props.decreaseCounter();

                } );

            }

        }, 500 );


    }

    getNonDeereClaimDownloadReport = ( report, payLoad, reportname ) => {

        this.props.increaseCounter();
        getFindClaimDownloadReports( report, payLoad ).then( response => {
            console.log("####",response.length);

            getAdminReportDownload( response, reportname );
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

    }

    multiEntryValidation = ( propertyName, propertyValue ) => {

        let multiEntry;
        if ( propertyName === 'pipNumbers' ) {

            const updatedpropertyValue = propertyValue.replace( /\n/g, ',' ),
                convertedArray = updatedpropertyValue.split( ',' );

            convertedArray.forEach( ( element, index ) => {

                convertedArray[index] = element;

            } );

            const cleanArr = convertedArray.filter( el => el !== null );
            multiEntry = cleanArr;

        } else {

            multiEntry = filterEmpty( propertyValue );

        }

        let validEntry = true;
        multiEntry.forEach( num => {

            const numb = propertyName === 'partNumber' ? isPartNumberValid( num ) : isAlphanumeric( num.trim(), propertyName );
            if ( !numb ) validEntry = false;

            return validEntry;

        } );

        return validEntry;

    }


    validatePartNumber = propertyValue => {

        const partNumbers = filterEmpty( propertyValue );
        let validEntry = true;
        partNumbers.forEach( num => {

            const numb = isPartNumberValid( num );
            if ( validEntry && ( !numb || num.trim() === '' || ( num.trim() ).length > 12 ) ) {

                validEntry = false;
                return false;

            }
            return validEntry;

        } );

        return validEntry;

    }


    validateModelCd = propertyValue => {

        const modelcds = filterEmpty( propertyValue );
        let validEntry = true;
        modelcds.forEach( num => {

            const numb = isModelCdValid( num );
            if ( validEntry && ( !numb || num.trim() === '' || ( num.trim() ).length > 5 ) ) {

                validEntry = false;
                return false;

            }
            return validEntry;

        } );

        return validEntry;

    }

    validateClaimNumber = propertyValue => {

        const claimNumbers = filterEmpty( propertyValue );
        let validEntry = true;
        const allowEmpty = false;
        claimNumbers.forEach( num => {

            const numb = isAlphanumeric( num, allowEmpty );
            if ( !numb || num.trim() === '' || ( num.trim() ).length > 12 ) {

                validEntry = false;
                return false;

            }
            return true;

        } );

        this.updateStatus( validEntry );
        return validEntry;

    }

    updateStatus = validEntry => {

        this.setState( {
            ...this.state,
            isValidEntry: validEntry,
        } );

    }

    validatePin = propertyValue => {

        const pipOrPip = filterEmpty( propertyValue );
        let validEntry = true;
        pipOrPip.forEach( num => {

            const numb = isAlphanumeric( num );
            if ( validEntry && ( !numb || num.trim() === '' || ( ( num.trim() ).length !== 13 && ( num.trim() ).length !== 17 ) ) ) {

                validEntry = false;
                // return false;

            }

            return validEntry;

        } );

        return validEntry;

    }

    
    validateMultiEntries = event => {

        // console.log("event.target",event.target);
        const propertyName = event.target.name;
        const propertyValue = ( event.target.value ).trim();

        this.setState( {
            isValidEntry: true,
        } );

        if ( propertyName === 'partNumbers' ) return this.validatePartNumber( propertyValue );
        if ( propertyName === 'partNumber' ) return this.validatePartNumber( propertyValue );
        if ( propertyName === 'claimNumbers' ) return this.validateClaimNumber( propertyValue );
        if ( propertyName === 'engineSerialNumbers' ) return isAlphanumeric( propertyValue, true );
        if ( propertyName === 'modelCdList' ) return this.validateModelCd( propertyValue );
        return this.validatePin( propertyValue );

    }

    updateCurrentState = properties => {

        const updatedInputs = { ...this.state.searchInputs };
        Object.keys( properties ).forEach( key => {

            updatedInputs[key] = properties[key];

        } );
        this.setState( {
            searchInputs: updatedInputs,
        } );
        this.updatedSrcInputs( getUserEditedInputs( updatedInputs ) );

    }

    updateMultiEntryInput = event => {

        const { name, value } = event.target;
        const updatedProps = cloneDeep( this.state.searchInputs );
        updatedProps[name] = value;

        this.setState( {
            searchInputs: updatedProps,
        } );
        this.updatedSrcInputs( getUserEditedInputs( updatedProps ) );

    }

    updateGridAPI = gridApi => {

        this.setState( {
            gridAPI: gridApi,
        } );

    }


    updateSearchInput = event => {

        const { name, value } = event.target,
            updatedProps = cloneDeep( this.state.searchInputs );
        let validateVal = isAlphanumeric( value > 0 ? value : true );
        if ( name === 'claimNumbers' ) validateVal = isAlphanumeric( value, false );
        else if ( name === 'engineSerialNumbers' ) validateVal = isAlphanumeric( value, true );
        else if ( name === 'partNumbers' ) validateVal = isPartNumberValid( value );
        else if ( name === 'partNumber' ) validateVal = isPartNumberValid( value );
        else if ( name === 'pipNumbers' ) validateVal = isAlphanumeric( value, true );
        else if ( name === 'modelCdList' ) validateVal = isAlphanumeric( value, true );
        if ( validateVal ) {

            if (name === "creditMemoNumber" || name === "workOrderNumber" || name === "dealerAccount") {
                updatedProps[name] = value.split(",").map(entry => entry.trim());
              } else {
                updatedProps[name] = value;
              }
              updatedProps[name] = value;
            this.setState( {
                searchInputs: updatedProps,
            } );
            this.updatedSrcInputs( getUserEditedInputs( updatedProps ) );

        }


    }


    onEditSearch = () => {

        this.setState( {
            isSearch: false,
        } );

    }

    onBackToResult = () => {

        this.setState( {
            isClaimDetails: false,
        } );

    }

    onNewSearch = () => {

        this.setState( {
            searchInputs: {
                claimNumbers: '',
                engineSerialNumbers: '',
                partNumbers: '',
                processDate: { from: 0, to: 0 },
                factoryCode: '',
            },
            modifiedSearch: [],
            isSearch: false,
            isClaimDetails: false,
            isSubmitted: false,
            factoryCode: '',
        } );

    }


    handleFactoryCodeChange = id => {

        const updatedProps = cloneDeep( this.state.searchInputs );
        updatedProps.factoryCode = ( id === '-1' ) ? '' : id;
        this.setState( {
            searchInputs: updatedProps,
        } );
        this.updatedSrcInputs( getUserEditedInputs( updatedProps ) );
        
    }


    rangeFromAndTo = ( props, range, data ) => {

        const obj = { ...this.state.searchInputs[props.name] };
        if ( range === 'from' ) {

            obj[range] = ( data === null || data === '' ) ? 0 : data;

        } else if ( range === 'to' ) {

            obj[range] = ( data === null || data === '' ) ? 0 : data;

        } else {

            obj.from = data;
            obj.to = data;

        }
        return obj;

    }

    handleRangeChange = ( props, range, data ) => {

        let rangeObj = {};

        if ( props.name === 'serialNumber' ) {

            const desired = data.replace( /[^0-9]+/g, '' ).trim();
            rangeObj = this.rangeFromAndTo( props, range, desired );

        } else {

            rangeObj = this.rangeFromAndTo( props, range, data );

        }

        this.setState( {
            [props.name]: rangeObj,
        } );

        const selectedOption = {
            target: {
                name: props.name,
                value: rangeObj,
            },
        };
        this.updateSearchInput( selectedOption );

    }

    getPreviousClaimDetails = () => {

        this.onClaimDetails( this.state.claimDetailsInfo.displayedClaimIndex - 1 );

    }

    getNextClaimDetails = () => {

        this.onClaimDetails( this.state.claimDetailsInfo.displayedClaimIndex + 1 );

    }


    onClaimDetails = clickedRowIndex => {
    // console.log("clickedRowIndex",clickedRowIndex);
        this.props.increaseCounter();
        const getClickedRowDetails = this.state.gridAPI.getDisplayedRowAtIndex( clickedRowIndex ),
            totalClaims = this.state.gridAPI.getDisplayedRowCount(),
            { warrantyClaimId } = getClickedRowDetails.data,
            { claimNumber } = getClickedRowDetails.data,
            updatedProps = cloneDeep( this.state.claimDetailsInfo );

        updatedProps.totalClaims = totalClaims;
        updatedProps.displayedClaimIndex = clickedRowIndex;

        this.setState( {
            claimDetailsInfo: updatedProps,
            selectedWarrantyClaimID: warrantyClaimId,
            selectedClaimNumber: claimNumber,
            selectedClaimData: getClickedRowDetails.data,
            isClaimDetails: true,


        } );

        this.props.decreaseCounter();

    }


    handleOutsideClick ( event ) {

        if ( event && event.target && event.target.closest( '.downloadwrp .dropdown' ) ) return;

        document.removeEventListener( 'click', this.handleOutsideClick, false );
        this.setState( {
            showDropDownMenu: false,
        } );

    }

    render () {
        const   factoryList = [
            {
                "factoryCode": "liebherr",
                "name": "Liebherr"
            },
            {
                "factoryCode": "claas",
                "name": "Claas"
            },
            {
                "factoryCode": "wirtgen",
                "name": "Wirtgen"
            }];
               
        return (
            <div>
                {!this.state.isSearch && (
                    <section>
                        <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter} />
                        <header>
                            <div>
                                <h2 className="page-header">
                                    Find Claim
                                </h2>

                            </div>
                            <div className="downloadwrp">
                                <button className="primary-button" onClick={this.onSubmit} type="button"><span> Submit </span></button>
                                <div className="dropdown">
                                    <button className="report-button" onClick={this.onSubmit} type="button" id="dropdownMenuButton1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        Download Report
                                    </button>
                                
                                </div>

                            </div>


                        </header>
                            <main>
                                <Accordion
                                    accordionId="basic-search-accordion"
                                    title="Basic Search"
                                    subTitle={this.accordionSecondaryText()}
                                    secondaryText={this.state.claimCount.basicSrcInps === 0 ?
                                        'None Selected' :
                                        `${this.state.claimCount.basicSrcInps} Selected`}
                                    isExpanded={true}
                                >
                                    <div className="rows three-cols">
                                        <OptionsDropDown
                                        isPlaceholderTranslated={true}
                                        optionDisplayAttributes={['name']}
                                        label="Factory Code"
                                        optionKey="factoryCode"
                                        options={factoryList}
                                        onChange={this.updateFactoryCode}
                                        placeholder="Select Factory"
                                        selectedValue={this.state.factoryCode}
                                        isRequired={true}
                                        />
                                        
                                    </div>
                                    {( !this.valuesHavingSeparators(
                                        this.state.searchInputs.claimNumbers,
                                    ) )
                                        && (
                                            <div className="rows three-cols">
                                                <InputWithFaIcon
                                                    className="Claim"
                                                    name="claimNumbers"
                                                    isEditable={true}
                                                    label="Claim Number"
                                                  //  maxLength={12}
                                                    value={this.state.searchInputs.claimNumbers}
                                                    onChange={this.updateSearchInput}
                                                    iconClassName="fa-plus-square"
                                                    isMandatory={false}
                                                    type="text"
                                                    onIconClick={this.initiatePopup.bind( this, 'claimNumbers' )}
                                                />
                                            </div>

                                        )}

                                    {( this.valuesHavingSeparators(
                                        this.state.searchInputs.claimNumbers,
                                    ) )
                                        && (
                                            <div className="rows three-cols">
                                                <div className="form-group claimnumbers edit-less">
                                                    <label>Claim Number</label>
                                                    <span className="asterisk-icon">
                                                        <i className="fa fa-asterisk" />
                                                    </span>
                                                    <div>
                                                        <span>
                                                            {' '}
                                                            {this.noOfEntries(
                                                                this.state
                                                                    .searchInputs.claimNumbers,
                                                            )}
                                                            {' '}
                                                            Selected
                                                            {' '}
                                                            <span className="pull-right multipleStyle">
                                                                <button
                                                                    type="button"
                                                                    className="Claim"
                                                                    onClick={this.initiatePopup.bind( this, 'claimNumbers' )}
                                                                >
                                                                    Edit Selection
                                                                    {' '}
                                                                </button>
                                                            </span>
                                                            {' '}

                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    {( !this.valuesHavingSeparators(
                                        this.state.searchInputs.engineSerialNumbers,
                                    ) )
                                        && (
                                            <div className="rows three-cols">
                                                <InputWithFaIcon
                                                    className="EngineSerial"
                                                    name="engineSerialNumbers"
                                                    isEditable={true}
                                                    label="Engine Serial Number"
                                                    value={this.state.searchInputs.engineSerialNumbers}
                                                    onChange={this.updateSearchInput}
                                                    iconClassName="fa-plus-square"
                                                    isMandatory={false}
                                                    type="text"
                                                    onIconClick={this.initiatePopup.bind( this, 'engineSerialNumbers' )}
                                                />
                                            </div>
                                        )}

                                    {( this.valuesHavingSeparators(
                                        this.state.searchInputs.engineSerialNumbers,
                                    ) )
                                        && (
                                            <div className="rows three-cols">
                                                <div className="form-group claimnumbers edit-less">
                                                    <label>Engine Serial Number</label>
                                                    <span className="asterisk-icon">
                                                        <i className="fa fa-asterisk" />
                                                    </span>
                                                    <div>
                                                        <span>
                                                            {' '}
                                                            {this.noOfEntries(
                                                                this.state.searchInputs.engineSerialNumbers,
                                                            )}
                                                            {' '}
                                                            Selected
                                                            {' '}
                                                            <span className="pull-right multipleStyle">
                                                                <button
                                                                    type="button"
                                                                    className="EngineSerial"
                                                                    onClick={this.initiatePopup.bind( this, 'engineSerialNumbers' )}
                                                                >
                                                                    Edit Selection
                                                                    {' '}
                                                                </button>
                                                            </span>
                                                            {' '}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                    {( !this.valuesHavingSeparators(
                                        this.state.searchInputs.partNumbers,
                                    ) )
                                        && (
                                            <div className="rows three-cols">
                                                <InputWithFaIcon
                                                    className="PartNumber"
                                                    name="partNumbers"
                                                    isEditable={true}
                                                    label="Part Number"
                                                    value={this.state.searchInputs.partNumbers}
                                                    onChange={this.updateSearchInput}
                                                    iconClassName="fa-plus-square"
                                                    isMandatory={false}
                                                    type="text"
                                                    onIconClick={this.initiatePopup.bind( this, 'partNumbers' )}
                                                />
                                            </div>
                                        )}

                                    {( this.valuesHavingSeparators(
                                        this.state.searchInputs.partNumbers,
                                    ) )
                                        && (
                                            <div className="rows three-cols">
                                                <div className="form-group claimnumbers edit-less">
                                                    <label>Part Number</label>
                                                    <span className="asterisk-icon">
                                                        <i className="fa fa-asterisk" />
                                                    </span>
                                                    <div>
                                                        <span>
                                                            {' '}
                                                            {this.noOfEntries(
                                                                this.state.searchInputs.partNumbers,
                                                            )}
                                                            {' '}
                                                            Selected
                                                            {' '}
                                                            <span className="pull-right multipleStyle">
                                                                <button
                                                                    type="button"
                                                                    className="PartNumber"
                                                                    onClick={this.initiatePopup.bind( this, 'partNumbers' )}
                                                                >
                                                                    Edit Selection
                                                                    {' '}
                                                                </button>
                                                            </span>
                                                            {' '}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    <div className="rows three-cols">
                                        <LabeledDateRangePicker
                                            to={this.state.searchInputs.processDate.to}
                                            from={this.state.searchInputs.processDate.from}
                                            onChange={this.handleRangeChange.bind( this )}
                                            className="process-date"
                                            name="processDate"
                                            label="Process Date"
                                            isRequired={false}
                                            dateFormat="MM/dd/yyyy"
                                        />
                                    </div>
                                    {this.state.isPopupOpen && (

                                        <SimpleMultipleEntryPopup
                                            panelName={this.state.popupName}
                                            isOpen={this.state.isPopupOpen}
                                            onClose={this.onClosePopup}
                                            onUpdateProperty={this.updateMultiEntryInput.bind(
                                                this.props,
                                            )}
                                            propertyName={this.state.popupPropertyName}
                                            propertyValue={this.state.popupPropertyValue}
                                            onApplyValidate={this.validateMultiEntries.bind(
                                                this.props,
                                            )}
                                            validateEntry={this.validatePin.bind( this )}
                                            isValidEntry={this.state.isValidEntry}
                                            multiEntryValidation={this.multiEntryValidation
                                                .bind( this, this.state.popupPropertyName )}
                                        />
                                    )}

                                </Accordion>
                                
                         
                            </main>

                    </section>
                )}
                {this.state.isSearch && (
                     <div className={( this.state.isClaimDetails ? ' hide' : ' show' )}>
                  
                        <NonDeereSearchResultPanel
                            searchedOptions={this.state.searchInputs.option || {}}
                            claimList={this.state.claimList}
                            onEditSearch={this.onEditSearch}
                            onNewSearch={this.onNewSearch}
                            searchedLabels={this.getSearchedLabels}
                            onClaimDetails={this.onClaimDetails.bind( this )}
                            editedInputs={this.state.modifiedSearch}
                            updateGridAPI={this.updateGridAPI.bind( this )}
                            callFrom="findClaim"
                            onToggleDiv={this.onToggleDiv}
                            showDropDownMenu={this.state.showDropDownMenu}
                            onSubmit={this.onSubmit}
                            factoryCode={this.state.searchInputs.factoryCode}

                        />
                        

    
                    </div>
                )}

                {this.state.isSearch && this.state.isClaimDetails && (
                    <div>
                        <NonDeereClaimDetails
                            claimData={this.state.selectedClaimData}
                            claimDetailsInfo={this.state.claimDetailsInfo}
                            factoryCode={this.state.factoryCode}
                            onBackToResult={this.onBackToResult}
                            getPreviousClaimDetails={this.getPreviousClaimDetails}
                            getNextClaimDetails={this.getNextClaimDetails}
                        />
                    </div>
                )}
            </div>
        );

    }

}
FindNonDeereClaim.displayName = 'FindNonDeereClaim';
FindNonDeereClaim.propTypes = {
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    reload: PropTypes.string,
    updateReload: PropTypes.func,
};
const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
} );
const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
    createErrorMessage: message => dispatch( createErrorMessage( message ) ),
} );
export default connect( mapStateToProps, mapDispatchToProps )( withRouter( FindNonDeereClaim ) );